/* Tubelight navbar
 * Adapted from the 21st.dev "tubelight-navbar" pattern (ayushmxxn) into vanilla
 * JS for Dawn. The original uses framer-motion's shared layoutId to slide the
 * indicator between tabs; here a single absolutely-positioned "lamp" element is
 * moved with a transform, which gives the same continuous slide without a
 * framework.
 */
(function () {
  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var list = nav.querySelector('ul.list-menu--inline');
    if (!list || list.dataset.aphLamp === 'true') return;

    var items = list.querySelectorAll(':scope > li');
    if (!items.length) return;

    var lamp = document.createElement('span');
    lamp.className = 'aph-lamp';
    lamp.setAttribute('aria-hidden', 'true');
    lamp.innerHTML = '<span class="aph-lamp__tube"></span>';
    list.appendChild(lamp);
    list.dataset.aphLamp = 'true';

    // The item matching the current page, else the first.
    var current = list.querySelector('li a[aria-current="page"]') ||
                  list.querySelector('li .list-menu__item--active');
    var home = current ? current.closest('li') : null;

    var settled = false;

    // strength: 'dim' while hovering around, 'full' for the page you are on
    // or the item you just clicked.
    function moveTo(li, animate, strength) {
      if (!li) return;
      var a = li.querySelector('a, summary');
      if (!a) return;
      var lr = list.getBoundingClientRect();
      var ir = a.getBoundingClientRect();
      if (!animate) lamp.style.transition = 'none';
      lamp.style.width = ir.width + 'px';
      lamp.style.transform = 'translateX(' + (ir.left - lr.left) + 'px)';
      lamp.classList.toggle('is-full', strength === 'full');
      lamp.classList.toggle('is-dim', strength !== 'full');
      if (!animate) {
        // force reflow so the next change animates
        void lamp.offsetWidth;
        lamp.style.transition = '';
      }
    }

    function reset() {
      if (home) {
        moveTo(home, true, 'full');
      } else {
        lamp.classList.remove('is-dim', 'is-full');
      }
    }

    for (var i = 0; i < items.length; i++) {
      (function (li) {
        li.addEventListener('mouseenter', function () { moveTo(li, settled, 'dim'); settled = true; });
        li.addEventListener('focusin', function () { moveTo(li, settled, 'dim'); settled = true; });
        // Clicking commits: full brightness, and it stays there.
        li.addEventListener('mousedown', function () {
          moveTo(li, true, 'full');
          home = li;
        });
      })(items[i]);
    }

    list.addEventListener('mouseleave', reset);
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) reset();
    });

    if (home) {
      moveTo(home, false, 'full');
      settled = true;
    }

    window.addEventListener('resize', function () {
      if (home) moveTo(home, false, 'full');
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor re-renders the header.
  document.addEventListener('shopify:section:load', init);
})();
